'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Truck;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Truck(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: (0, _classnames2.default)('icon-svg-truck', className),
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: color, d: 'M1.2 1.75c-.333 0-.617.117-.85.35-.233.233-.35.517-.35.85v8.6c0 .167.058.308.175.425a.579.579 0 0 0 .425.175h1c0 .667.233 1.233.7 1.7.467.467 1.033.7 1.7.7s1.233-.233 1.7-.7c.467-.467.7-1.033.7-1.7h3.2c0 .667.233 1.233.7 1.7.467.467 1.033.7 1.7.7s1.233-.233 1.7-.7c.467-.467.7-1.033.7-1.7h1a.579.579 0 0 0 .425-.175.579.579 0 0 0 .175-.425v-.4a.579.579 0 0 0-.175-.425.579.579 0 0 0-.425-.175h-.2v-2.7c0-.333-.117-.617-.35-.85l-2.5-2.5a1.157 1.157 0 0 0-.85-.35h-1.1v-1.2c0-.333-.117-.617-.35-.85a1.157 1.157 0 0 0-.85-.35h-8zM12 13.35c-.333 0-.617-.117-.85-.35a1.157 1.157 0 0 1-.35-.85c0-.333.117-.617.35-.85.233-.233.517-.35.85-.35.333 0 .617.117.85.35.233.233.35.517.35.85 0 .333-.117.617-.35.85-.233.233-.517.35-.85.35zm-1.6-5.2v-2.8h1.1l2.5 2.5v.3h-3.6zM4 13.35c-.333 0-.617-.117-.85-.35a1.157 1.157 0 0 1-.35-.85c0-.333.117-.617.35-.85.233-.233.517-.35.85-.35.333 0 .617.117.85.35.233.233.35.517.35.85 0 .333-.117.617-.35.85-.233.233-.517.35-.85.35z', fillRule: 'evenodd' })
  );
}

Truck.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Truck/Truck.js
// module id = 337
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15